import { combineReducers } from 'redux';
//admin
import DashboardReducer from './adminreducers/DashboardReducers';
import AHospitalReducers from './adminreducers/AHospitalReducers'
import AViewHospitalReducers from './adminreducers/AViewHospitalReducers';
import ADoctorlistReducers from './adminreducers/ADoctorlistReducers';
import  AviewDoctorReducers from './adminreducers/AviewDoctorReducers';
import ACasesReducers from './adminreducers/ACasesReducers';
import ACountryReducers from './adminreducers/ACountryReducers';
import ASpecialityReducers from './adminreducers/ASpecialityReducers';
import ALanguageReducers from './adminreducers/ALanguageReducers';
import AOfficerReducers from './adminreducers/AOfficerReducers';
import APlanReducers from './adminreducers/APlanReducers';
import AActivitiesReducers from './adminreducers/AActivitiesReducers';
import ARegionRegions from './adminreducers/ARegionReducers';
import APaymentsReducers from './adminreducers/APaymentsReducers';


//suprivisor
import SuprivisorDashReducers from './suprivisorreduucers/SuprivisorDashReducers';
import SupDoctorsReucers from './suprivisorreduucers/SupDoctorsReducers';
import SupAssReducers from './suprivisorreduucers/SupAssReducers';
import SupLinkAssistantsReducers from './suprivisorreduucers/SupLinkAssistantsReducers';
import SupViewDcotorReducers from './suprivisorreduucers/SupViewDcotorReducers';
import SuprivisorReportsReducers from './suprivisorreduucers/SuprivisorReportsReducers';
import SupActivitiesReducers from './suprivisorreduucers/SupActiviesReducers';
import SupApplicationsReducers from './suprivisorreduucers/SupApplicationsReducers';
import SupViewAssReducers from './suprivisorreduucers/SupViewAssReducers';
import SupDocReportsReducers from './suprivisorreduucers/SupDocReportsReducers';
import SupViewApproveReducers from './suprivisorreduucers/SupViewApproveReducers';
import SuprivisorProfileReducers from './suprivisorreduucers/SuprivisorProfileReducers';
import SupDocumentsReducers from './suprivisorreduucers/SupDocumentsReducers';
import SupAssistantDetReducers from './suprivisorreduucers/SupAssistantDetReducers';





//medicalofficer
import MOApplicationReducers from './medicalofficerreducers/MOApplicationReducers';
import MOActivitiesReducers from './medicalofficerreducers/MOActivitiesReducers';
import MOApprovedReducers from './medicalofficerreducers/MOApprovedReducers';
import MOProfileReducers from './medicalofficerreducers/MOProfileReducers';

//doctorapprover
import DODoctorReducers from './doctorapproverreducers/DODoctorReducers';
import DOActivityReudcers from './doctorapproverreducers/DOActivityReducers';
import DOViewDoctorReducers from './doctorapproverreducers/DOViewDoctorReducers';
import DOProfileReducers from './doctorapproverreducers/DOProfileReducers';
import DoctorApproverHeaderReducers from './doctorapproverreducers/DoctorApproverHeaderReducers';

//doctor
import DoctorCasesReducers from './doctorreducers/DoctorCasesReducers';
import DoctorReportsReducers from './doctorreducers/DoctorReportsReducers';
import DoctorActivityReducers from './doctorreducers/DoctorActivityReducers';
import DoctorProfileReducers from './doctorreducers/DoctorProfileReducers';
import DoctorViewCaseReducers from './doctorreducers/DoctorViewCaseReducers';
import PatientHistoryReducers from './doctorreducers/PatientHistoryReducers';
import DoctorDashboardReducers from './doctorreducers/DoctorDashboardReducers';
import DoctorNotesReducers from './doctorreducers/DoctorNotesReducers';


//patient
import PatientCasesReducers from './patientreducers/PatientCasesReducers';
import NewCaseReducers from './patientreducers/NewCaseReducers';
import PatientFamilyReducers from './patientreducers/PatientFamilyReducers';
import PatientReportsReducers from './patientreducers/PatientReportsReducers';
import PatientApplicationsReducers from './patientreducers/PatientApplicationsReducers';
import PatientDashboardReducers from './adminreducers/DashboardReducers';
import PatientProfileReducers from './patientreducers/PatientProfileReducers';


///finance officer

import FOApplicationReducers from './financeofficerreducers/FOApplicationReducers';
import FOActivitiesReducers from './financeofficerreducers/FOActivitiesReducers';
import FOProfileReducers from './financeofficerreducers/FOProfileReducers';

//Consultancy Officer
import COActivitiesreducers from './ConOfficerreducers/COActivitiesreducers';
import COLoginreducers from './ConOfficerreducers/COLoginreducers';
import COProfilereducers from './ConOfficerreducers/COProfilereducers';
import AssistantProfileReducers from './doctorapproverreducers/AssistantProfileReducers';

import ResetReducers from './ResetReducers';

const rootReducer = combineReducers({
//admin
    dashborad:DashboardReducer,
    ahospital:AHospitalReducers,
    viewhospital:AViewHospitalReducers,
    adoctor:ADoctorlistReducers,
    cases:ACasesReducers,
    countrydata:ACountryReducers,
    speciality:ASpecialityReducers,
    language:ALanguageReducers,
    officer:AOfficerReducers,
    plan:APlanReducers,
    activities:AActivitiesReducers,
    regions:ARegionRegions,
    payments:APaymentsReducers,
    viewdoctor:AviewDoctorReducers,



//suprivisor
sdash:SuprivisorDashReducers,
sdoctorss:SupDoctorsReucers,
sasslist:SupAssReducers,
slinkass:SupLinkAssistantsReducers,
sviewdct:SupViewDcotorReducers,
sreports:SuprivisorReportsReducers,
sactivities:SupActivitiesReducers,
sapplications:SupApplicationsReducers,
sviewassreports:SupViewAssReducers,
sviewdocreports:SupDocReportsReducers,
sviewapprovedapplication:SupViewApproveReducers,
sprofile:SuprivisorProfileReducers,
sdoc:SupDocumentsReducers,
sassistantdetails:SupAssistantDetReducers,



//medicalofficer
mapplication:MOApplicationReducers,
mactivity:MOActivitiesReducers,
mapprovedview:MOApprovedReducers,
mprofile:MOProfileReducers,


//finance office

fapplication:FOApplicationReducers,
finactivities:FOActivitiesReducers,
fprofile:FOProfileReducers,
//doctorappover
dadoctor:DODoctorReducers,
daactivity:DOActivityReudcers,
daviewDoc:DOViewDoctorReducers,
daprofile:DOProfileReducers,
doctorapproverheader:DoctorApproverHeaderReducers,

//doctor
doctorcaseslist:DoctorCasesReducers,
doctorreports:DoctorReportsReducers,
doctoractivity:DoctorActivityReducers,
doctorprofile:DoctorProfileReducers,
doctorviewopencase:DoctorViewCaseReducers,
patienthistory:PatientHistoryReducers,
doctordashboard:DoctorDashboardReducers,
doctornotes:DoctorNotesReducers,
//patient
patientcases:PatientCasesReducers,
newcase:NewCaseReducers,
patientfamily:PatientFamilyReducers,
patientreports:PatientReportsReducers,
patientapplications:PatientApplicationsReducers,
patientdashboard:PatientDashboardReducers,
patientprofile:PatientProfileReducers,



//Consultancy Officer
coactivities: COActivitiesreducers,
cologin: COLoginreducers,
cprofile: COProfilereducers,
assistantprofilerole:AssistantProfileReducers,

//reset
reset:ResetReducers,

});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;

